const data = {
  id: 1,
  title: 'Listen and find out the word',
  subTitle: 'Nghe và chọn từ',
  question: 'Nghe và chọn từ có âm / ʃ /',
  answers: [
    { id: 1, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/48dbc76f-e3be-48b0-b439-d15a1b990e14.mp3' },
    { id: 2, answer: '', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/bbee4c41-f969-42fc-8861-4545262cca45.mp3' },
    { id: 3, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/714dec90-ded4-4bd0-a403-9c1a567d1a3a.mp3' },
    { id: 4, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/7885218b-ecdd-44eb-bd5d-918df386b12c.mp3' },
  ],
};

export default data;
